<template>
  <div style="margin-top: 63px">
    <v-alert class="alert-info" type="success" :value="show_alert">
      {{ $t('career.copySuccessMessage') }}
    </v-alert>
    <popup :message="errMessage" v-if="isErr" @close="isErr = false" />
    <div class="hero">
      <div class="content">
        <h1>{{ $t('career.heroTitle') }}</h1>
        <p>{{ $t('career.heroSubtitle') }}</p>
        <div class="btn-cta">
          <button class="now" @click="scrollToSection">
            {{ $t('career.ctaButton1') }}
          </button>
          <button class="call" @click="sendToWa">
            {{ $t('career.ctaButton2') }}
          </button>
        </div>
      </div>
      <div class="card-img">
        <img src="/img/career/main.png" width="520" height="" alt="" style="border-radius: 0 0 0 80px" />
      </div>
    </div>
    <div class="unique-selling-proposition">
      <h1 class="text-center poppins-font usp-title">
        {{ $t('career.uspTitle') }}
        <div class="content">
          <div class="row">
            <div class="col-lg-4 items" v-for="(item, idx) in usps" :key="idx">
              <div class="card text-start" style="background-color: white">
                <img :src="item.img" alt="" width="60" height="60" />
                <div class="label">
                  <p class="sub-title">{{ item.name }}</p>
                  <p class="description">
                    {{ item.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </h1>
    </div>
    <div class="bg-gradient">
      <StepCollaboration :title="$t('career.stepsTitle')" :steps="steps" bgColor="white" />
    </div>
    <div class="unique-selling-proposition">
      <h1 class="text-center poppins-font usp-title">
        {{ $t('career.jobOpportunitiesTitle') }}
      </h1>
      <div class="content">
        <v-row gap="4">
          <v-col cols="5">
            <div class="action-head">
              <div class="f-search">
                <div class="f-search-ic">
                  <img src="/img/icons/search.png" alt="Search Ic" />
                </div>
                <div style="width: 90%">
                  <v-text-field v-model="filter.position" type="text" class="f-input"
                    :placeholder="$t('career.searchPlaceholder')" dense flat solo></v-text-field>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="2.5">
            <v-select outlined color="#ACAFBF" :placeholder="$t('career.workTypePlaceholder')"
              v-model="filter.work_type" :items="workTypeList" :item-text="'name'" :item-value="'value'"
              style="border-radius: 10px !important; background-color: white" hide-details />
          </v-col>
          <v-col cols="2.5">
            <v-select outlined color="#ACAFBF" :placeholder="$t('career.levelPlaceholder')" v-model="filter.level"
              :items="levelList" :item-text="'name'" :item-value="'value'"
              style="border-radius: 10px !important; background-color: white" hide-details />
          </v-col>
          <v-col>
            <Button :name="$t('career.searchButton')" width="100%" height="54px" @click="searchCareer" />
          </v-col>
        </v-row>
        <div class="list-career">
          <div class="list-career-ctn" v-for="(data, idx) in listCareer" :key="idx"
            @click="goToCareerDetail(data.slug_name, data.name)">
            <img :src="$utils.emptyLogo(data.logo)" />
            <div class="mb-3" style="height: 70px;">
              <h2>{{ data.name }}</h2>
            </div>
            <p style="font-weight: 500">{{ data.company }}</p>
            <p style="font-weight: 400">{{ data.location }}</p>
            <div class="career-data">
              <div class="label">
                <div style="background-color: #f1f6ff" v-if="data.contract_type">
                  <clock-ic width="18px" height="18px" />
                  <p>{{ data.contract_type }}</p>
                </div>
                <div style="background-color: #faeceb" v-if="data.work_type">
                  <location-ic width="18px" height="18px" />
                  <p>{{ data.work_type }}</p>
                </div>
                <div style="background-color: #faf6e7" v-if="data.level">
                  <level-ic width="18px" height="18px" />
                  <p>{{ data.level }}</p>
                </div>
              </div>
            </div>
            <div class="btn-daftar">
              <div class="btn-daftar-act">
                <Button :name="$t('career.applyNowButton')" width="100%" @click="() => toCheckout(data)" />
              </div>
              <div class="btn-daftar-cpy">
                <div class="button-outline" @click.stop="() => onCopy(data.slug_name)">
                  <CopyIc width="25px" height="25px" />
                </div>
              </div>
            </div>
            <p class="text-center">
              {{ $t('career.batasAt') }}
              <b style="font-family: 'Poppins'">{{ moment(data.closed_at) }}</b>
            </p>
          </div>
        </div>
        <EmptyData v-if="!listCareer || !listCareer.length" :message="$t('career.noJobsMessage')" />
        <v-row justify="center mt-10" v-if="total > 1">
          <v-col>
            <Pagination @pageChanged="onPageChanged" :currentPage="currentPage" :totalPages="total" />
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="faq" style="margin-top: 0px">
      <div class="content">
        <div class="row">
          <div class="col-lg-3">
            <div class="header" style="margin-bottom: 20px">
              <h1>{{ $t('career.faqTitle') }}</h1>
            </div>
          </div>
          <div class="col-lg-9" style="margin-top: -10px">
            <v-expansion-panels flat class="faq-card" style="padding: 20px; background-color: #f1f6ff">
              <v-expansion-panel v-for="(item, index) in questions" :key="index"
                style="border-radius: 20px; padding: 0; margin-bottom: 10px">
                <v-expansion-panel-header disable-icon-rotate @click="openFaq(index, item.title)">
                  <h2 style="margin: 25px 0; font-size: 18px">
                    {{ item.title }}
                  </h2>
                  <template v-slot:actions>
                    <div class="icon" v-if="item.active">
                      <Arrow />
                    </div>
                    <div v-else>
                      <Arrow :down="!item.active" />
                    </div>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-html="item.description"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <div class="btn-stoke-blue" @click="goToFaq">
              <span class="font-poppins">{{ $t('career.seeAllButton') }}</span>
              <ArrowLong />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepCollaboration from "@/components/corporate/StepCollaboration.vue";
import Button from "../../../others/Button.vue";
import CopyIc from "@/assets/icons/career/Copy.vue";
import EmptyData from "../../../others/EmptyData.vue";
import ClockIc from "@/assets/icons/career/Clock.vue";
import LevelIc from "@/assets/icons/career/Level.vue";
import LocationIc from "@/assets/icons/career/Location.vue";
import moment from "moment";
import ArrowLong from "@/assets/icons/ArrowLong.vue";
import Popup from "@/components/others/Popup.vue";
import Arrow from '@/assets/icons/Arrow.vue';
import Pagination from '@/components/others/Pagination.vue'

export default {
  name: "DesktopCareer",
  components: {
    StepCollaboration,
    Button,
    Arrow,
    ArrowLong,
    ClockIc,
    LevelIc,
    LocationIc,
    CopyIc,
    EmptyData,
    Popup,
    Pagination
  },
  data() {
    return {
      filter: {
        position: "",
        work_type: "",
        level: "",
      },
      errMessage: "",
      isErr: false,
      show_alert: false,
      currentPage: 1,
      total: 1,
      questions: [],
      testimonies: [],
      workTypeList: [
        { name: "Full-Time", value: "Full-Time" },
        { name: "Part-Time", value: "Part-Time" },
        { name: "Freelance", value: "Freelance" },
        { name: "Internship", value: "Internship" },
      ],
      levelList: [
        { name: "Head", value: "Head" },
        { name: "Senior", value: "Senior" },
        { name: "Middle", value: "Middle" },
        { name: "Junior", value: "Junior" },
      ],
      listCareer: [],
    };
  },
  computed: {
    usps() {
      return [
        {
          img: "/img/about/c2.png",
          name: this.$t('career.uspItems.0.name'),
          description: this.$t('career.uspItems.0.description'),
        },
        {
          img: "/img/about/b6.png",
          name: this.$t('career.uspItems.1.name'),
          description: this.$t('career.uspItems.1.description'),
        },
        {
          img: "/img/about/b4.png",
          name: this.$t('career.uspItems.2.name'),
          description: this.$t('career.uspItems.2.description'),
        },
      ];
    },
    steps() {
      return [
        {
          image_url: "/img/corporate/tech/bn1.png",
          title: this.$t('career.steps.0.title'),
          description: this.$t('career.steps.0.description'),
        },
        {
          image_url: "/img/corporate/tech/bn2.png",
          title: this.$t('career.steps.1.title'),
          description: this.$t('career.steps.1.description'),
        },
        {
          image_url: "/img/corporate/tech/bn3.png",
          title: this.$t('career.steps.2.title'),
          description: this.$t('career.steps.2.description'),
        },
        {
          image_url: "/img/corporate/tech/bn4.png",
          title: this.$t('career.steps.3.title'),
          description: this.$t('career.steps.3.description'),
        },
        {
          image_url: "/img/corporate/tech/bn5.png",
          title: this.$t('career.steps.4.title'),
          description: this.$t('career.steps.4.description'),
        },
        {
          image_url: "/img/corporate/tech/bn5.png",
          title: this.$t('career.steps.5.title'),
          description: this.$t('career.steps.5.description'),
        },
      ];
    },
  },
  watch: {
    show_alert() {
      if (!this.show_alert) return;
      setTimeout(() => {
        this.show_alert = false;
      }, 3000);
    },
    "$i18n.locale"() {
      this.getTestimoni();
      this.getCareer();
      this.getFaq();
    },
  },
  methods: {
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Free Consultation - Career Page',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6282127274632&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    scrollToSection() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'View Job Opportunities - Hero Section',
        value: 1,
      });
      window.scrollTo(0, 1500);
    },
    page(act) {
      if (act === "prev") {
        if (this.currentPage <= 1) return;
        this.currentPage--;
      } else {
        if (this.currentPage >= this.total) return;
        this.currentPage++;
      }
      this.$gtag.event('click', {
        event_category: 'Pagination',
        event_label: `Page ${act === 'prev' ? 'Previous' : 'Next'} - Page ${this.currentPage}`,
        value: 1,
      });
      this.getCareer();
    },
    moment(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    toCheckout(data) {
      if (new Date() > new Date(data.closed_at)) return;
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `Apply Now - ${data.name}`,
        value: 1,
      });
      this.$router.push(`/career/applicant/${data.slug_name}`);
    },
    openFaq(idx, title) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `Open FAQ - ${title}`,
        value: 1,
      });
      const valDef = this.questions[idx].active;
      this.questions.forEach((e) => {
        e.active = false;
      });
      this.questions[idx].active = !valDef;
    },
    onCopy(id) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Copy URL - Career',
        value: 1,
      });
      const clipboardData =
        event.clipboardData ||
        window.clipboardData ||
        event.originalEvent?.clipboardData ||
        navigator.clipboard;
      clipboardData.writeText(`${window.location.href}${id}`);
      this.show_alert = true;
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=CAREER&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        this.isErr = true;
        this.errMessage = err.response.data.data;
      }
    },
    async getTestimoni() {
      try {
        const resp = await this.$http.get(`/v1/testimony?category=CAREER&is_active=true&page=1&per_page=4`);
        this.testimonies = resp.data.data.testimonies;
      } catch (err) {
        this.isErr = true;
        this.errMessage = err.response.data.data;
      }
    },
    async getCareer() {
      try {
        const res = await this.$http.get(`/v1/career?position=${this.filter.position}&level=${this.filter.level}&work_type=${this.filter.work_type}&page=${this.currentPage}&per_page=9`);
        this.$set(this, "listCareer", res.data.data.careers);
        this.total = Math.floor(res.data.data.total / 9) + 1;
      } catch (err) {
        console.log(err);
      }
    },
    searchCareer() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Search Careers',
        value: 1,
      });
      this.currentPage = 1;
      this.getCareer();
    },
    onPageChanged(page) {
      this.$gtag.event('click', {
        event_category: 'Pagination',
        event_label: `Page Change - Page ${page}`,
        value: 1,
      });
      this.currentPage = page;
      this.getCareer();
    },
    goToCareerDetail(slug, name) {
      this.$gtag.event('click', {
        event_category: 'Career',
        event_label: `View Career - ${name}`,
        value: 1,
      });
      this.$router.push(`/career/${slug}`);
    },
    goToFaq() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'View More FAQs',
        value: 1,
      });
      this.$router.push('/faq');
    },
  },
  mounted() {
    this.getFaq();
    this.getTestimoni();
    this.getCareer();
  },
};
</script>

<style src="./career.css" scoped></style>
